import config from './config.xml';
import tasks from './sample-sin.json';
import annotation from './annotations/1.json';

export const TimeSeries = { config, tasks, annotation };
